import { gql } from "@apollo/client";
import { ContaminationDeclarationValidityFields } from "../fragments/contaminationDeclarationValidity";

// Lightweight lookup for indicators: `null` (no error) means no declaration
// has been started for this ASSET_REMOVE event yet. `validity` comes through
// the shared fragment — selecting fewer fields here than the editor does would
// truncate the editor's copy of the same cache entity.
//
// `contaminationDeclarationAvailability` rides along in the same document
// rather than in a hook of its own: it is a second root field taking the same
// argument, so it costs no extra round trip on a lookup every DoC indicator
// already performs. It answers "may a declaration be *started* here" — the form
// is currently US-only, gated on the owning client's CRM region. It says
// nothing about reading, editing or printing one that exists; see
// installed-base-backend `docs/adr/0021-the-declaration-is-offered-per-region.md`.
export const ContaminationDeclarationForEvent = gql`
    query ContaminationDeclarationForEvent ($installedBaseEventId: ID!) {
        contaminationDeclarationForEvent (installedBaseEventId: $installedBaseEventId) {
            id
            declarationAccepted
            updatedAt
            validity {
                ...ContaminationDeclarationValidityFields
            }
        }
        contaminationDeclarationAvailability (installedBaseEventId: $installedBaseEventId)
    }
    ${ContaminationDeclarationValidityFields}
`;
